import { useCallback } from 'react'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'

import { fetchContactsWithSameRole } from '../../api'
import { IContact } from '../../model/types'

interface IUseHPRoleCheckDuplicates {
  contact: IContact
}

export const HIERARCHY_TYPE_WITH_FILTER_BY_PARTNER = [
  PartnerHierarchyType.AFFILIATE,
  PartnerHierarchyType.SUBSIDIARY,
  PartnerHierarchyType.RESELLER_NETWORK,
]

export const useHPRoleCheckDuplicates = ({ contact }: IUseHPRoleCheckDuplicates) => {
  const isFilterByPartnerId = HIERARCHY_TYPE_WITH_FILTER_BY_PARTNER.includes(contact.hierarchyType)

  const isHeadquarter = contact.hierarchyType === PartnerHierarchyType.HEADQUARTERS

  const partnerId = isHeadquarter || isFilterByPartnerId ? contact.partnerId : contact.topPartnerId

  const contactId = contact.contactId

  const checkRemoteDuplicates = useCallback(
    (role: string) =>
      fetchContactsWithSameRole({
        role,
        contactId,
        partnerId,
        isFilterByPartnerId,
      }),
    [contactId, isFilterByPartnerId, partnerId]
  )

  const checkHPRoleDuplicates = useCallback(
    async (role?: string) => {
      if (!role) {
        return
      }

      return checkRemoteDuplicates(role)
    },
    [checkRemoteDuplicates]
  )

  return {
    checkHPRoleDuplicates,
  }
}
